import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { AclDataSlice, createAclDataSlice, ACL_DATA_INITIAL_STATE } from './slices/createAclDataSlice';
import { AclUiSlice, createAclUiSlice, ACL_UI_INITIAL_STATE } from './slices/createAclUiSlice';
import { AclModalSlice, createAclModalSlice, ACL_MODAL_INITIAL_STATE } from './slices/createAclModalSlice';

export const ACL_INITIAL_STATE = {
  ...ACL_DATA_INITIAL_STATE,
  ...ACL_UI_INITIAL_STATE,
  ...ACL_MODAL_INITIAL_STATE,
};

export const useGroupsAclStore = create<AclDataSlice & AclUiSlice & AclModalSlice>()(
  devtools((...a) => ({
    ...createAclDataSlice(...a),
    ...createAclUiSlice(...a),
    ...createAclModalSlice(...a),
  }))
);
